import { render, staticRenderFns } from "./MigrateNotice.vue?vue&type=template&id=6b65ed1c&scoped=true&"
import script from "./MigrateNotice.vue?vue&type=script&lang=js&"
export * from "./MigrateNotice.vue?vue&type=script&lang=js&"
import style0 from "./MigrateNotice.vue?vue&type=style&index=0&id=6b65ed1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b65ed1c",
  null
  
)

export default component.exports